import Swal, { SweetAlertIcon } from "sweetalert2";

interface AppConfirmI {
  title: string;
  html?: string;
  text?: string;
  icon?: string;
  iconHtml?: string;
  showConfirmButton?: boolean;
  showCancelButton?: boolean;
  showDenyButton?: boolean;
  confirmButtonColor?: string;
  cancelButtonColor?: string;
  denyButtonColor?: string;
  confirmButtonText?: string;
  cancelButtonText?: string;
  denyButtonText?: string;
  showLoaderOnConfirm?: boolean;
  preConfirm?: any;
  additionalProps?: any;
}

interface AppInputConfirmI {
  title: string;
  text?: string;
  html?: string;
  inputLabel?: string;
  confirmButtonText?: string;
  confirmButtonColor?: string;
  deleteValue?: string;
}

interface AppAcknowledge {
  title: string;
  text: string;
  icon?: SweetAlertIcon;
  confirmButtonText?: string;
  confirmButtonColor?: string;
}

// Current Documentation for Swal2: https://sweetalert2.github.io/
export const AppConfirm = ({
  title,
  html,
  text,
  icon = "warning",
  iconHtml,
  // SHOW / HIDE Buttons
  showConfirmButton = true,
  showCancelButton = true,
  showDenyButton = false,
  // COLORS
  confirmButtonColor = "var(--danger)",
  cancelButtonColor = "var(--dark)",
  denyButtonColor = "black",
  // BUTTON TEXT
  confirmButtonText = "Delete",
  cancelButtonText = "Cancel",
  denyButtonText = "Deny",
  // Promises
  showLoaderOnConfirm = false,
  preConfirm = null,
  // Additional props
  additionalProps = {},
}: AppConfirmI) => {
  return Swal.fire({
    title: title,
    ...(html && { html: html }),
    ...(text && { text: text }),
    ...(iconHtml ? { iconHtml: iconHtml } : { icon: icon }),
    showLoaderOnConfirm: showLoaderOnConfirm,
    ...(preConfirm && { preConfirm: preConfirm }),
    showConfirmButton: showConfirmButton,
    showCancelButton: showCancelButton,
    showDenyButton: showDenyButton,
    confirmButtonColor: confirmButtonColor,
    cancelButtonColor: cancelButtonColor,
    denyButtonColor: denyButtonColor,
    confirmButtonText: confirmButtonText,
    cancelButtonText: cancelButtonText,
    denyButtonText: denyButtonText,
    ...additionalProps,
  });
};

// For deleting something important
// Requires user to type the name of the item they are deleting.
export const AppInputConfirm = ({
  title,
  text, // Used for description under title
  html, // Used for description under title, only provide text or html not both.
  deleteValue = "", // The value the user must type to be able to confirm.
  inputLabel = "",
  confirmButtonText = "Delete",
  confirmButtonColor = "var(--danger)",
}: AppInputConfirmI) => {
  return Swal.fire({
    title: title,
    ...(html && { html: html }),
    ...(text && { text: text }),
    input: "text",
    inputLabel: inputLabel,
    confirmButtonText: confirmButtonText,
    confirmButtonColor: confirmButtonColor,
    showCancelButton: true,
    inputValidator: (value) => {
      if (value.toLowerCase() !== deleteValue.toLowerCase()) {
        return "Values don't match!";
      }
    },
  });
};

// Acknowledgement of message
export const AppAcknowledge = ({
  title,
  text,
  icon = "info",
  confirmButtonText = "OK",
  confirmButtonColor = "var(--primary)",
}: AppAcknowledge) => {
  return Swal.fire({
    title: title,
    text: text,
    icon: icon,
    confirmButtonText: confirmButtonText,
    confirmButtonColor: confirmButtonColor,
  });
};
